import React from 'react';
import { Link } from 'react-router-dom';
import type { Lang } from '../offers/config';
const CONTENT = {
  es: {
    label: 'Metodologia',
    title: 'El Marco de Decision de Blinkblis',
    intro: 'Ninguna recomendacion aqui sale de una corazonada. Cada una pasa por los mismos cinco pasos, en el mismo orden.',
    steps: [{
      t: 'Investigar',
      d: 'Revisamos el producto, la categoria y la necesidad real del lector.'
    }, {
      t: 'Comparar',
      d: 'Evaluamos alternativas por costo, valor, riesgo y facilidad de acceso.'
    }, {
      t: 'Puntuar',
      d: 'Asignamos un Nivel de Confianza segun la calidad de los datos y la claridad de la diferencia.'
    }, {
      t: 'Revisar',
      d: 'Verificamos las afirmaciones, los limites y las desventajas antes de publicar.'
    }, {
      t: 'Recomendar',
      d: 'Explicamos para quien es, y para quien no lo es.'
    }],
    link: 'Ver la metodologia completa'
  },
  en: {
    label: 'Methodology',
    title: 'The Blinkblis Decision Framework',
    intro: 'No recommendation here comes from a hunch. Each one goes through the same five steps, in the same order.',
    steps: [{
      t: 'Research',
      d: 'We review the product, the category and the reader actual need.'
    }, {
      t: 'Compare',
      d: 'We weigh alternatives on cost, value, risk and accessibility.'
    }, {
      t: 'Score',
      d: 'We assign a Confidence Level based on data quality and how clear the difference is.'
    }, {
      t: 'Review',
      d: 'We verify claims, limits and downsides before publishing.'
    }, {
      t: 'Recommend',
      d: 'We explain who it is for, and who it is not for.'
    }],
    link: 'See the full methodology'
  }
};
export function DecisionFramework({
  lang
}: {
  lang: Lang;
}) {
  const c = CONTENT[lang];
  return <section className="mb-14 rounded-3xl border border-white/10 bg-white/[0.02] p-6 sm:p-8" data-id="element-25" data-mp="2ql6vnmdqod6w">
      <span className="text-[12px] uppercase tracking-[0.14em] text-accent" data-id="element-26" data-mp="2qn1gl0p0g5az">
        {c.label}
      </span>
      <h2 className="font-display text-[24px] sm:text-[28px] font-semibold tracking-[-0.02em] mt-3 mb-3" data-id="element-27" data-mp="2zlvbmmmp0nmf">
        {c.title}
      </h2>
      <p className="text-[16px] text-white/50 font-light leading-relaxed mb-8 max-w-xl" data-id="element-28" data-mp="2ulqrmmmktarg">
        {c.intro}
      </p>

      <ol className="relative border-l border-white/10 ml-3" data-id="element-29" data-mp="39ihu54rjr2la">
        {c.steps.map((s, i) => <li key={s.t} className="relative pl-7 pb-7 last:pb-0" data-id="element-30" data-mp="34kgc8n5ux9be" data-mpi={i}>
            <span className="absolute -left-[13px] top-0 w-[26px] h-[26px] rounded-full bg-background border border-accent/40 text-accent text-[12px] font-semibold flex items-center justify-center" data-id="element-31" data-mp="3icwalantcj5z">
              {i + 1}
            </span>
            <h3 className="text-white font-medium text-[16px] mb-1" data-id="element-32" data-mp="3sb2axntz1h8q">{s.t}</h3>
            <p className="text-[14px] text-white/50 leading-relaxed font-light" data-id="element-33" data-mp="3ncintk3n5zes">
              {s.d}
            </p>
          </li>)}
      </ol>

      <Link to="/metodologia" className="inline-block mt-7 text-[14px] text-accent hover:underline" data-id="element-34" data-mp="fqy5qbu81d5u">
        {c.link} →
      </Link>
    </section>;
}